namespace PaperTrail.Common {
    @Serenity.Decorators.registerEditor()

    export class ExtendedHtmlContentEditor extends Serenity.HtmlReportContentEditor {

        constructor(textArea: JQuery, opt?: Serenity.HtmlContentEditorOptions) {
            super(textArea, opt);
        }

        protected getConfig(): Serenity.CKEditorConfig {
            var config = super.getConfig();
            (config as any).allowedContent = true;
            (config as any).autoParagraph = true;
            return config;
        }
    }
}